// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 1H12V11.7699L2 1.54777V22.9999L22 23V20.5H18V18.5H22V16.75H18V14.75H22V13H18V11H22V9.25H18V7.25H22V5.5H18V3.5H22V1ZM12 14.63V21L4 21V6.45223L12 14.63Z"}}]};

const MathematicsFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'mathematics-filled',
    ref,
    icon: element,
  },
));

MathematicsFilledIcon.displayName = 'MathematicsFilledIcon';

export default MathematicsFilledIcon;
